import { render, staticRenderFns } from "./PValueModal.vue?vue&type=template&id=5356284c&scoped=true&"
import script from "./PValueModal.vue?vue&type=script&lang=js&"
export * from "./PValueModal.vue?vue&type=script&lang=js&"
import style0 from "./PValueModal.vue?vue&type=style&index=0&id=5356284c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356284c",
  null
  
)

export default component.exports